module.exports = __webpack_public_path__ + "img/bookcase-bottom.8caffa1a.svg";